import*as React from'react';/**
 * @ignore - internal component.
 */var ListContext=/*#__PURE__*/React.createContext({});if(process.env.NODE_ENV!=='production'){ListContext.displayName='ListContext';}export default ListContext;